module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/diners-8f7100a1473e927b8ee32386d887e4f2.svg";